// export
import { BASE_URL } from 'constant';
import privateFetch from 'PrivateFetch';

// INITIAL STATE
export const INITIAL_STATE = {
    status: '',
    loading: false,
    data: [],
    error: false
}

// CONSTANTA
export const EOD_GET_LOADING = 'EOD_GET_LOADING';
export const EOD_GET_SUCCESS = 'EOD_GET_SUCCESS';
export const EOD_GET_ERROR = 'EOD_GET_ERROR';

export const EOD_SAVE_LOADING = 'EOD_SAVE_LOADING';
export const EOD_SAVE_SUCCESS = 'EOD_SAVE_SUCCESS';
export const EOD_SAVE_ERROR = 'EOD_SAVE_ERROR';

export const EOD_UPDATE_LOADING = 'EOD_UPDATE_LOADING';
export const EOD_UPDATE_SUCCESS = 'EOD_UPDATE_SUCCESS';
export const EOD_UPDATE_ERROR = 'EOD_UPDATE_ERROR';

export const EOD_DELETE_LOADING = 'EOD_DELETE_LOADING';
export const EOD_DELETE_SUCCESS = 'EOD_DELETE_SUCCESS';
export const EOD_DELETE_ERROR = 'EOD_DELETE_ERROR';

export const EOD_LIST_LOADING = 'EOD_LIST_LOADING';
export const EOD_LIST_SUCCESS = 'EOD_LIST_SUCCESS';
export const EOD_LIST_ERROR = 'EOD_LIST_ERROR';

export const EOD_VIEW_LOADING = 'EOD_VIEW_LOADING';
export const EOD_VIEW_SUCCESS = 'EOD_VIEW_SUCCESS';
export const EOD_VIEW_ERROR = 'EOD_VIEW_ERROR';

export const EOD_MASTER_LOADING = 'EOD_MASTER_LOADING';
export const EOD_MASTER_SUCCESS = 'EOD_MASTER_SUCCESS';
export const EOD_MASTER_ERROR = 'EOD_MASTER_ERROR';

export const EOD_PAYMENT_LOADING = 'EOD_PAYMENT_LOADING';
export const EOD_PAYMENT_SUCCESS = 'EOD_PAYMENT_SUCCESS';
export const EOD_PAYMENT_ERROR = 'EOD_PAYMENT_ERROR';

// const dispatch

const eodGetLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_GET_LOADING,
        loading: bool
    }
}

const eodGetSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: EOD_GET_SUCCESS,
        data
    }
}

const eodGetError = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_GET_ERROR,
        error: bool
    }
}

const eodSaveLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_SAVE_LOADING,
        loading: bool
    }
}

const eodSaveSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: EOD_SAVE_SUCCESS,
        data
    }
}

const eodSaveError = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_SAVE_ERROR,
        error: bool
    }
}

const eodUpdateLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_UPDATE_LOADING,
        loading: bool
    }
}

const eodUpdateSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: EOD_UPDATE_SUCCESS,
        data
    }
}

const eodUpdateError = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_UPDATE_ERROR,
        error: bool
    }
}

const eodDeleteLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_DELETE_LOADING,
        loading: bool
    }
}

const eodDeleteSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: EOD_DELETE_SUCCESS,
        data
    }
}

const eodDeleteError = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_DELETE_ERROR,
        error: bool
    }
}

const eodListLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_LIST_LOADING,
        loading: bool
    }
}

const eodListSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: EOD_LIST_SUCCESS,
        data
    }
}

const eodListError = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_LIST_ERROR,
        error: bool
    }
}

const eodViewLoading = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_VIEW_LOADING,
        loading: bool
    }
}

const eodViewSuccess = (bool, data) => {
    return {
        ...INITIAL_STATE,
        type: EOD_VIEW_SUCCESS,
        data
    }
}

const eodViewError = bool => {
    return {
        ...INITIAL_STATE,
        type: EOD_VIEW_ERROR,
        error: bool
    }
}

const eodMasterLoading = bool => {
    return {
        // ...INITIAL_STATE,
        type: EOD_MASTER_LOADING,
        loading: bool
    }
}

const eodMasterSuccess = (bool, data) => {
    return {
        // ...INITIAL_STATE,
        type: EOD_MASTER_SUCCESS,
        success: bool,
        data
    }
}

const eodMasterError = bool => {
    return {
        // ...INITIAL_STATE,
        type: EOD_MASTER_ERROR,
        error: bool
    }
}

const eodPaymentLoading = bool => {
    return {
        // ...INITIAL_STATE,
        type: EOD_PAYMENT_LOADING,
        loading: bool
    }
}

const eodPaymentSuccess = (bool, data) => {
    return {
        // ...INITIAL_STATE,
        type: EOD_PAYMENT_SUCCESS,
        success: bool,
        data
    }
}

const eodPaymentError = bool => {
    return {
        // ...INITIAL_STATE,
        type: EOD_PAYMENT_ERROR,
        error: bool
    }
}

export function eodGet(data) {
    let url = BASE_URL + 'custom_params/page';
    return privateFetch(eodGetSuccess, eodGetError, eodGetLoading, 'POST', url, data);
}

export function eodList(data) {
    let url = BASE_URL + 'custom_params/list';
    return privateFetch(eodListSuccess, eodListError, eodListLoading, 'POST', url, data);
}

export function eodSave(data) {
    let url = BASE_URL + 'custom_params/save';
    return privateFetch(eodSaveSuccess, eodSaveError, eodSaveLoading, 'POST', url, data);
}

export function eodUpdate(data) {
    let url = BASE_URL + 'custom_params/update';
    return privateFetch(eodUpdateSuccess, eodUpdateError, eodUpdateLoading, 'POST', url, data);
}

export function eodDelete(data) {
    let url = BASE_URL + 'custom_params/delete';
    return privateFetch(eodDeleteSuccess, eodDeleteError, eodDeleteLoading, 'POST', url, data);
}

export function eodView(data) {
    let url = BASE_URL + 'custom_params/view';
    return privateFetch(eodViewSuccess, eodViewError, eodViewLoading, 'POST', url, data);
}

export function eodMaster(data) {
    let url = BASE_URL + 'custom_params/custom_params_master';
    return privateFetch(eodMasterSuccess, eodMasterError, eodMasterLoading, 'POST', url, data);
}

export function eodPayment(data) {
    let url = BASE_URL + 'payment_channel/list';
    return privateFetch(eodPaymentSuccess, eodPaymentError, eodPaymentLoading, 'POST', url, data);
}

